import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '.';
import { PublicFormContact } from '../classes/public-form-contact';

@Injectable()
export class SendMailService {

  constructor(private httpService: HttpService) { }

  public sendMail(email: PublicFormContact): Observable<any> {
    return this.httpService.pathV2().post('contato/comercial', email);
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/services/send-mail.service.ts